import {
  Flex,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Button, PageHeading } from "barte-design-system";
import { useNavigate } from "react-router-dom";

const NotaFiscalConfig = () => {
  const navigate = useNavigate();
  return (
    <>
      <Flex w="100%" direction="column">
        <PageHeading
          title="Nota Fiscal"
        />
        <Stack maxW="550px" gap={4}>
          <Text>
            Sua Nota Fiscal ainda não está configurada. Para configurar, acesse o formulário abaixo.
          </Text>
        </Stack>
        <Button
          style={{ maxWidth: "200px", marginTop: "1rem" }}
          onClick={() => window.open("https://form.typeform.com/to/FcE3JDxh")}
        >
          Configurar Nota Fiscal
        </Button>
      </Flex>
    </>
  );
};

export default NotaFiscalConfig;
